import { render, staticRenderFns } from "./FootballPage.vue?vue&type=template&id=7bdd91ee&"
import script from "./FootballPage.vue?vue&type=script&lang=js&"
export * from "./FootballPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports